import React, { useCallback } from 'react';
import { Button, Image, Modal } from 'antd';

const PreviewModal = ({ isVisible, fileUrl, onClose }) => {
    const handleDownload = useCallback(() => {
        if (fileUrl) {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = fileUrl.split('/').pop(); // Extracts the filename from the URL
            link.click();
        } else {
            console.error("Download URL is not available.");
        }
    }, [fileUrl]);

    const renderPreviewContent = useCallback(() => {
        if (!fileUrl) {
            return <p className='text-light-textWhite font-medium text-base'>No preview available</p>;
        }

        if (fileUrl.endsWith(".pdf")) {
            return (
                <div>
                    <iframe src={fileUrl} width="500" height="500" title="Preview" />
                </div>
            );
        }

        return (
            <Image
                src={fileUrl}
                alt="Preview"
                className='md:w-80 md:!max-h-80 object-contain m-auto'
            />
        );
    }, [fileUrl]);

    const footerButtons = useCallback(() => [
        <Button key="cancel" onClick={onClose} className='cancel-btn'>
            Close
        </Button>,
        <Button key="download" type="primary" onClick={handleDownload} className='primary-btn px-4 py-1 rounded-5 font-medium'>
            Download
        </Button>
    ], [onClose, handleDownload]);

    return (
        <Modal
            className='text-lightWhite !mt-6 md:mt-0 preview-modal'
            open={isVisible}
            title="Preview"
            width={"100%"}
            footer={[
                <div key="footer-container" className='mt-2 md:flex justify-end gap-2 space-y-2 md:space-y-0'>
                    {footerButtons()}
                </div>
            ]}
            onCancel={onClose}
            // classNames="md:!w-[500px] !w-full"
        >
            <div className='mt-5'>
                {renderPreviewContent()}
            </div>
        </Modal>
    );
};

export default PreviewModal;
